import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class SearchPopup extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      open: "-open",
      modalOpen: "-modal-open",
      submenuVisible: "-submenu-visible",
    }
  }

  ui() {
    return {
      searchInput: ".header-navigation-search-input",
      navigationItems: ".header-navigation-item",
    }
  }

  toggle(event) {
    const { open, modalOpen, submenuVisible } = this.dynamicClasses
    const isOpening = !this.$el.classList.contains(open)
    const isUserInitiated = event && event.isTrusted

    this.$el.classList.toggle(open)
    document.body.classList.toggle(modalOpen)

    if (isOpening) {
      // Clear input
      this.$ui.searchInput.value = ""

      // Hide search results
      this.$ui.searchInput.parentElement.querySelector(
        ".predictive-search-results"
      ).style.display = "none"

      // Close all submenus
      const navigationItems = this.$el.querySelectorAll(
        this.ui().navigationItems
      )
      navigationItems.forEach((item) => {
        item.classList.remove(submenuVisible)
        const submenu = item.querySelector("[data-height]")
        if (submenu) {
          submenu.style.height = 0
        }
      })

      // Focus handling for iOS
      if (isUserInitiated) {
        // Direct focus for user-initiated events (works on iOS)
        this.$ui.searchInput.focus()
      } else {
        // Fallback for programmatic toggles (desktop/non-iOS)
        requestAnimationFrame(() => {
          this.$ui.searchInput.focus()
        })
      }
    }
  }

  attachEvents() {
    const { open } = this.dynamicClasses
    const links = document.querySelectorAll(".search-popup-toggle")

    iterable(links).forEach((link) => {
      link.addEventListener("click", (e) => {
        this.toggle(e)
        e.preventDefault()
      })
    })

    window.addEventListener("keyup", (e) => {
      if (e.code === "Escape" && this.$el.classList.contains(open)) {
        this.toggle(e)
      }
    })
  }

  created() {
    this.attachEvents()
  }
}
